import i18n from "@/lang/index";
import siteType from "../configs/siteType";

const data = {
  mannin: {
    iconHref:
      "https://www.gov.im/categories/business-and-industries/gambling-and-e-gaming/licence-holders",
    about: process.env.VUE_APP_KKPOKER_OFFICE + "/about",
    termsOfService: process.env.VUE_APP_KKPOKER_OFFICE + "/TermsOfService",
    privacyPolicy: process.env.VUE_APP_KKPOKER_OFFICE + "/PrivacyPolicy",
    affiliateMarketing:
      process.env.VUE_APP_KKPOKER_OFFICE + "/AffiliateMarketing",
    notice: process.env.VUE_APP_KKPOKER_OFFICE + "/restricted_prompt",
    noticeCountries:
      process.env.VUE_APP_KKPOKER_OFFICE + "/restricted_territory",
    APPLE_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? "" : APPLE_VERSION,
    ANDROID_LINK: i18n.locale === "mn" ? MN_ANDROID_VERSION : ANDROID_VERSION,
    WINDOWS_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS
        ? ""
        : i18n.locale === "mn"
        ? MN_WINDOWS_VERSION
        : WINDOWS_VERSION,
    MAC_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? "" : MAC_VERSION,
    WEB_LINK: WEB_VERSION,
    icon: "/static/img/home/icon_06.png",
    LAB_POLICY: "register.LAB_POLICY",
    LAB_CLUB_CHECK_TEMS4: "register.LAB_CLUB_CHECK_TEMS4",
    LAB_ACCESS: "register.LAB_ACCESS",
    LAB_SERVICE: "register.LAB_SERVICE",
    menuList: [
      { link: "https://br.kkpoker.net/", label: "INÍCIO" },
      { link: "https://br.kkpoker.net/tournaments", label: "TORNEIOS" },
      { link: "https://br.kkpoker.net/promotions", label: "PROMOÇÕES" },
      { link: "https://br.kkpoker.net/blog", label: "BLOG" },
    ],
    olakkLogo: "https://br.kkpoker.net/",
    protectPhoto: "register.LAB_CONTENT_4",
    uspLink: {
      instantRakeback: "https://www.kkpoker.net/instant-rakeback/",
      promotion: "https://www.kkpoker.net/promotions/",
    },
    andriodOnly: ["Maldive", "Norway", "Malaysia"],
    kkLogoLink: process.env.VUE_APP_KKPOKER_OFFICE,
  },
  curacao: {
    iconHref:
      "https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbE14TDIwdmQySk1OMjQwU1RORWVsUk5RMUpGWkZFOVBTSXNJblpoYkhWbElqb2lhM1p3YTFoWlRXZGhNRkkwUWxwTVNscFJkMFJqVVQwOUlpd2liV0ZqSWpvaU5XWTRZalk1WVRBeE1ERmlOR1l3TURNNE5XUmpNVGRpTkRZNFlqTTVaVEZqTVRJd05ERXpOV1kyTW1Fek16UXhaRGd5WkRVeFlqaG1aR0V5TlRRNE5pSXNJblJoWnlJNklpSjk=",
    about: process.env.VUE_APP_KKPOKER_OFFICE_CO + "/about",
    termsOfService: process.env.VUE_APP_KKPOKER_OFFICE_CO + "/TermsOfService",
    privacyPolicy:
      process.env.VUE_APP_KKPOKER_OFFICE_CO +
      "/privacymanagementofpersonaldata",
    affiliateMarketing:
      process.env.VUE_APP_KKPOKER_OFFICE_CO + "/AffiliateMarketing",
    notice: process.env.VUE_APP_KKPOKER_OFFICE_CO + "/restrictedprompt",
    noticeCountries:
      process.env.VUE_APP_KKPOKER_OFFICE_CO + "/restricted_territory",
    APPLE_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? "" : APPLE_CO_VERSION,
    ANDROID_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS
        ? ""
        : ANDROID_CO_VERSION,
    WINDOWS_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS
        ? ""
        : WINDOWS_CO_VERSION,
    MAC_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? "" : MAC_CO_VERSION,
    WEB_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? "" : WEB_CO_VERSION,
    icon: "https://seal.cgcb.info/8b089e55-4795-425a-6bf6-fdb75eba6900",
    LAB_POLICY: "register.LAB_PRIVACYPOLICE_CO",
    LAB_CLUB_CHECK_TEMS4: "register.LAB_CLUB_CHECK_TEMS4_CO",
    LAB_ACCESS: "register.LAB_ACCESS_CO",
    LAB_SERVICE: "register.LAB_SERVICE_CO",
    menuList: [
      { link: "https://kkpoker.co/", label: "INÍCIO" },
      { link: "https://kkpoker.co/", label: "TORNEIOS" },
      { link: "https://kkpoker.co/", label: "PROMOÇÕES" },
      { link: "https://kkpoker.co/", label: "BLOG" },
    ],
    olakkLogo: "https://kkpoker.co/",
    protectPhoto: "register.LAB_CONTENT_4_CO",
    uspLink: {
      instantRakeback: "https://kkpoker.co/instantrakeback",
      promotion: null,
    },
    andriodOnly: [
      "Bahrain",
      "Egypt",
      "Jordan",
      "Kuwait",
      "Lebanon",
      "Qatar",
      "Saudi Arabia",
      "The United Arab Emirates",
      "Mauritania",
      "Bangladesh",
      "South Korea",
    ],
    kkLogoLink: process.env.VUE_APP_KKPOKER_OFFICE_CO,
  },
  denmark: {
    iconHref:
      "https://www.gov.im/categories/business-and-industries/gambling-and-e-gaming/licence-holders",
    about: process.env.VUE_APP_KKPOKER_OFFICE + "/about",
    termsOfService: process.env.VUE_APP_KKPOKER_OFFICE + "/TermsOfService",
    privacyPolicy: process.env.VUE_APP_KKPOKER_OFFICE + "/PrivacyPolicy",
    affiliateMarketing:
      process.env.VUE_APP_KKPOKER_OFFICE + "/AffiliateMarketing",
    notice: process.env.VUE_APP_KKPOKER_OFFICE + "/pc/restricted_prompt",
    noticeCountries:
      process.env.VUE_APP_KKPOKER_OFFICE + "/restricted_territory",
    APPLE_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? "" : APPLE_VERSION,
    ANDROID_LINK: i18n.locale === "mn" ? MN_ANDROID_VERSION : ANDROID_VERSION,
    WINDOWS_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS
        ? ""
        : i18n.locale === "mn"
        ? MN_WINDOWS_VERSION
        : WINDOWS_VERSION,
    MAC_LINK:
      siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? "" : MAC_VERSION,
    WEB_LINK: WEB_VERSION,
    icon: "/static/img/home/icon_06.png",
    LAB_POLICY: "register.LAB_POLICY",
    LAB_CLUB_CHECK_TEMS4: "register.LAB_CLUB_CHECK_TEMS4",
    LAB_ACCESS: "register.LAB_ACCESS",
    LAB_SERVICE: "register.LAB_SERVICE",
    menuList: [
      { link: "https://br.kkpoker.net/", label: "INÍCIO" },
      { link: "https://br.kkpoker.net/tournaments", label: "TORNEIOS" },
      { link: "https://br.kkpoker.net/promotions", label: "PROMOÇÕES" },
      { link: "https://br.kkpoker.net/blog", label: "BLOG" },
    ],
    olakkLogo: "https://br.kkpoker.net/",
    protectPhoto: "register.LAB_CONTENT_4",
    uspLink: {
      instantRakeback: "https://www.kkpoker.net/instant-rakeback/",
      promotion: "https://www.kkpoker.net/promotions/",
    },
    andriodOnly: ["Brazil", "Maldive", "Norway", "Malaysia"],
    kkLogoLink: process.env.VUE_APP_KKPOKER_OFFICE,
  },
  nuts: {
    iconHref:
      "https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbE14TDIwdmQySk1OMjQwU1RORWVsUk5RMUpGWkZFOVBTSXNJblpoYkhWbElqb2lhM1p3YTFoWlRXZGhNRkkwUWxwTVNscFJkMFJqVVQwOUlpd2liV0ZqSWpvaU5XWTRZalk1WVRBeE1ERmlOR1l3TURNNE5XUmpNVGRpTkRZNFlqTTVaVEZqTVRJd05ERXpOV1kyTW1Fek16UXhaRGd5WkRVeFlqaG1aR0V5TlRRNE5pSXNJblJoWnlJNklpSjk=",
    about: process.env.VUE_APP_OFFICE + "/about",
    termsOfService: process.env.VUE_APP_OFFICE + "/TermsOfService",
    privacyPolicy:
      process.env.VUE_APP_OFFICE + "/privacymanagementofpersonaldata",
    affiliateMarketing: process.env.VUE_APP_OFFICE + "/AffiliateMarketing",
    notice: process.env.VUE_APP_OFFICE + "/restrictedprompt",
    noticeCountries: process.env.VUE_APP_OFFICE + "/restrictedterritory",
    APPLE_LINK: "",
    ANDROID_LINK: ANDROID_VERSION,
    WINDOWS_LINK: "",
    WEB_LINK: WEB_VERSION,
    icon: "https://seal.cgcb.info/8b089e55-4795-425a-6bf6-fdb75eba6900",
    LAB_POLICY: "register.LAB_PRIVACYPOLICE_CO",
    LAB_CLUB_CHECK_TEMS4: "register.LAB_CLUB_CHECK_TEMS4_CO",
    LAB_ACCESS: "register.LAB_ACCESS_CO",
    LAB_SERVICE: "register.LAB_SERVICE_CO",
    menuList: [
      { link: "https://nutspoker.cc/", label: "INÍCIO" },
      { link: "https://nutspoker.cc/", label: "TORNEIOS" },
      { link: "https://nutspoker.cc/", label: "PROMOÇÕES" },
      { link: "https://nutspoker.cc/", label: "BLOG" },
    ],
    olakkLogo: "https://nutspoker.cc/",
    protectPhoto: "register.LAB_CONTENT_4_CO",
    uspLink: {
      instantRakeback: "https://nutspoker.cc/instantrakeback",
      promotion: null,
    },
    andriodOnly: [
      "Bahrain",
      "Egypt",
      "Jordan",
      "Kuwait",
      "Lebanon",
      "Qatar",
      "Saudi Arabia",
      "The United Arab Emirates",
      "Mauritania",
      "Bangladesh",
      "South Korea",
    ],
    kkLogoLink: process.env.VUE_APP_OFFICE,
  },
};

export const globalConfigMixin = {
  computed: {
    globalConfig() {
      console.log('globalConfig', this.$root.currentType);
      
      if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
        return data["nuts"];
      } else {
        return data[this.$root.currentType] || {};
      }
    },
    // APPLE_DOWNLOAD() {
    //   return this.globalConfig.APPLE_LINK;
    // },
    // ANDROID_DOWNLOAD() {
    //   return this.globalConfig.ANDROID_LINK;
    // },
    // WINDOWS_DOWNLOAD() {
    //   return this.globalConfig.WINDOWS_LINK;
    // },
    // MAC_DOWNLOAD() {
    //   return this.globalConfig.MAC_LINK;
    // },
    // WEB_DOWNLOAD() {
    //   return this.globalConfig.WEB_LINK;
    // },
  },
};
